import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import "../styles/blogs.css";

const blogsData = [
  {
    id: 1,
    title: "How to Register and Verify Your Account on the Reddyanna App",
    date: "2024-09-29",
    author: "Vikash Roy",
    views: 5731,
    likes: 623,
    comments: 0,
    excerpt:
      "Learn how to easily register and verify your account on the Reddyanna app. Follow...",
    imageUrl: "/blog1.webp",
    slug: "how-to-register-and-verify-your-account-on-the-reddyanna-app",
  },
  {
    id: 2,
    title: "Reddy Anna App: Features, Benefits, and Installation Guide",
    date: "2024-09-25",
    author: "Vikash Roy",
    views: 5391,
    likes: 593,
    comments: 0,
    excerpt:
      "Explore the features, benefits, and a complete installation guide for the Reddy...",
    imageUrl: "/blog2.webp",
    slug: "reddy-anna-app-features-benefits-and-installation-guide",
  },
  {
    id: 3,
    title: "Online Cricket Betting: From How to Place Bet to Successful Tips",
    date: "2025-04-25",
    author: "Vikash Roy",
    views: 6078,
    likes: 493,
    comments: 0,
    excerpt:
      "Learn how to place a bet, how to win, and how to make money with online cricket betting. Follow...",
    imageUrl: "/blog3.webp",
    slug: "online-cricket-betting-from-how-to-place-bet-to-successful-tips",
  },
  {
    id: 4,
    title: "Cricket Betting Tips 2025: Expert Guide for Beginners to Win Big",
    date: "2025-04-30",
    author: "Vikash Roy",
    views: 5869,
    likes: 440,
    comments: 0,
    excerpt:
      "Cricket is so much more than just a game, it's a worldwide phenomenon that brings countries...",
    imageUrl: "/blog4.webp",
    slug: "cricket-betting-tips-2025-expert-guide-for-beginners-to-win-big",
  },
  {
    id: 5,
    title: "Exploring the Exciting World of Cricket Betting Exchanges",
    date: "2025-05-14",
    author: "Vikash Roy",
    views: 6721,
    likes: 515,
    comments: 0,
    excerpt:
      "For many cricket fans, watching a match is more than just a game — it's a passion. The sound of the ...",
    imageUrl: "/blog5.webp",
    slug: "exploring-the-exciting-world-of-cricket-betting-exchanges",
  },
  // {
  //   id: 6,
  //   title: "Decoding the Matrix: A Guide into Cricket Betting Odds",
  //   date: "2025-05-20",
  //   author: "Vikash Roy",
  //   views: 6081,
  //   likes: 398,
  //   comments: 0,
  //   excerpt: "Understand how cricket betting odds work, how to read them, and how live odds can guide smarter bets...",
  //   imageUrl: "/blog6.webp",
  //   slug: "decoding-the-matrix-a-guide-into-cricket-betting-odds",
  // }
  {
    id: 7,
    slug: "the-art-and-science-of-cricket-betting-prediction",
    title: "The Art and Science of Cricket Betting Prediction",
    date: "2025-05-22",
    author: "Vikash Roy",
    views: 6121,
    likes: 306,
    comments: 0,
    excerpt:
      "Cricket is a game of glorious uncertainties, which is precisely why it's so captivating. But...",
    imageUrl: "/blog7.webp",
  },
  {
    id: 8,
    slug: "mastering-the-art-how-to-bet-in-cricket-online",
    title: "Mastering the Art: How to Bet in Cricket Online",
    date: "2025-05-24",
    author: "Vikash Roy",
    views: 5771,
    likes: 306,
    comments: 0,
    excerpt:
      "Cricket has always been a game of glorious uncertainties. That same unpredictability fuels...",
    imageUrl: "/blog8.webp",
  },
  {
    id: 9,
    slug: "tennis-the-ultimate-betting-playbook",
    title: "Tennis: The Ultimate Betting Playbook",
    date: "2025-05-30",
    author: "Vikash Roy",
    views: 8881,
    likes: 201,
    comments: 0,
    excerpt:
      "Tennis is one of the most entertaining sports to bet on due to its unpredictabilit...",
    imageUrl: "/blog9.webp",
  },
  {
    id: 10,
    slug: "the-ultimate-playbook-how-to-bet-on-football-games",
    title: "The Ultimate Playbook: How to Bet on Football Games",
    date: "2025-06-02",
    author: "Vikash Roy",
    views: 7781,
    likes: 341,
    comments: 0,
    excerpt:
      " Football, which is known as football in many parts of the world, is not just the globe's...",
    imageUrl: "/blog10.webp",
  },
  {
    id: 11,
    slug: "tennis-betting-odds-everything-you-need-to-know",
    title: "Tennis Betting Odds: Everything You Need to Know",
    date: "2025-06-07",
    author: "Vikash Roy",
    views: 8931,
    likes: 479,
    comments: 0,
    excerpt:
      " Tennis betting odds play a vital role in sports betting, giving you insight into the...",
    imageUrl: "/blog11.webp",
  },
  {
    id: 12,
    slug: "us-open-tennis-betting-what-you-need-to-know-before-you-place-a-bet",
    title:
      "US Open Tennis Betting: What You Need to Know Before You Place a Bet",
    date: "2025-06-23",
    author: "Vikash Roy",
    views: 7194,
    likes: 89,
    comments: 0,
    excerpt:
      "The U.S. Open is where tennis dreams are made and betting fortunes are found...",
    imageUrl: "/blog12.webp",
  },
  {
    id: 13,
    slug: "tennis-betting-odds-your-complete-guide-to-winning-big",
    title: "Tennis Betting Odds: Your Complete Guide to Winning Big",
    date: "2025-06-23",
    author: "Vikash Roy",
    views: 7642,
    likes: 759,
    comments: 0,
    excerpt:
      " Tennis betting has really come into its own over the past 10 years, and it's become...",
    imageUrl: "/blog13.webp",
  },
    {
    id: 14,
    slug: "top-10-fantasy-cricket-picks-for-this-week-ipl-special",
    title: "Top 10 Fantasy Cricket Picks for This Week (IPL Special)",
    date: "2026-05-01",
    author: "Vikash Roy",
    views: 1236,
    likes: 235,
    comments: 0,
    excerpt:
      "If you've been playing fantasy cricket during the Indian Premier League, you already know one thing — it's not just about picking big names anymore...",
    imageUrl: "/blog14.webp",
  },
  {
    id: 15,
    slug: "how-to-win-fantasy-sports-consistently-advanced-strategies-2026-guide",
    title: "How to Win Fantasy Sports Consistently: Advanced Strategies (2026 Guide)",
    date: "2026-04-30",
    author: "Vikash Roy",
    views: 3245,
    likes: 632,
    comments: 0,
    excerpt:
      "Winning in fantasy sports in 2026 isn't about your luck — consistently winning is possible when you understand the patterns and make calculated decisions...",
    imageUrl: "/blog15.webp",
  },
  {
    id: 16,
    slug: "womens-cricket-betting-boom-in-2026-wpl-and-international-opportunities",
    title: "Women's Cricket Betting Boom in 2026: WPL & International Opportunities",
    date: "2026-06-08",
    author: "Vikash Roy",
    views: 2356,
    likes: 789,
    comments: 0,
    excerpt:
      "Women's cricket has come a long way, and 2026 is proving to be one of its most exciting years so far. The WPL delivered non-stop entertainment earlier this year, and now with the ICC Women's T20 World Cup happening in England and Wales...",
    imageUrl: "/blog16.webp",
  },
  {
    id: 17,
    slug: "betting-exchange-game-the-complete-guide-for-beginners-and-experienced-players",
    title: "Betting Exchange Game: The Complete Guide for Beginners and Experienced Players",
    date: "2026-06-08",
    author: "Vikash Roy",
    views: 1256,
    likes: 532,
    comments: 0,
    excerpt:
      "The online betting world has changed a lot in the last decade. One of the most interesting changes is the rise of betting exchanges. Unlike regular sportsbooks, where you bet against the house, betting exchanges let people bet against each other...",
    imageUrl: "/blog17.webp",
  },
  {
  id: 18,
  slug: "best-online-cricket-id-why-reddy-book-club-is-the-preferred-choice-for-cricket-enthusiasts",
  title: "Best Online Cricket ID: Why Reddy Book Club Is the Preferred Choice for Cricket Enthusiasts",
  date: "2026-07-15",
  author: "Vikash Roy",
  views: 442,
  likes: 578,
  comments: 0,
  excerpt:
    "Learn about online cricket IDs, understand how platforms like Reddy Book Club are discussed online, and explore safety, privacy, and legal considerations.",
  imageUrl: "/blog18.webp",
},
{
  id: 19,
  slug: "anna-matka-guide",
  title: "Anna Matka: A Complete Guide to Understanding the Risks and Online Safety",
  date: "2026-07-16",
  author: "Vikash Roy",
  views: 735,
  likes: 635,
  comments: 0,
  excerpt:
    "Learn about Anna Matka, explore Reddy Book insights, and understand key safety, legal, and responsible gambling risks in online platforms.",
  imageUrl: "/blog19.webp",
},
{
  id: 20,
  slug: "best-online-id-online-safety-guide",
  title: "Best Online ID: A Complete Guide to Online Safety and Understanding Reddy Anna Book Club",
  date: "2026-07-24",
  author: "Vikash Roy",
  views: 8765,
  likes: 5687,
  comments: 0,
  excerpt:
    "Learn what Best Online ID means, understand Reddy Anna Book Club, and explore online safety, privacy, and responsible decision-making.",
  imageUrl: "/blog20.webp",
},
{
  id: 21,
  slug: "anna-matka-guide",
  title: "Anna Matka: Understanding the Game, Its Popularity, and the Role of Reddy Book Club",
  date: "2026-08-13",
  author: "Vikash Roy",
  views: 8765,
  likes: 5687,
  comments: 0,
  excerpt:
    "Learn about Anna Matka, Reddy Book Club, online safety, responsible gaming, and important factors to consider before using online gaming platforms.",
  imageUrl: "/blog21.webp",
},
{
  id: 22,
  slug: "best-online-cricket-id",
  title: "Best Online Cricket ID | Secure & Fast Access | Reddy Book Club",
  date: "2026-08-11",
  author: "Vikash Roy",
  views: 7640,
  likes: 6460,
  comments: 0,
  excerpt:
    "Find the best online cricket ID with secure registration, fast access, competitive betting options, and trusted support from Reddy Book Club.",
  imageUrl: "/blog22.webp",
},
{
  id: 23,
  slug: "online-betting-id",
  title: "Online Betting ID | Secure Access & Casino Online Game",
  date: "2026-08-11",
  author: "Vikash Roy",
  views: 7633,
  likes: 3534,
  comments: 0,
  excerpt:
    "Get a secure online betting ID with Reddy Book Club. Enjoy sports betting and casino online game options with fast registration and safe payments.",
  imageUrl: "/blog23.webp",
},
{
  id: 24,
  slug: "reddy-book-club-best-online-cricket-id",
  title: "Reddy Book Club & Best Online Cricket ID Guidell",
  date: "2026-09-14",
  author: "Vikash Roy",
  views: 2000,
  likes: 3000,
  comments: 1520,
  excerpt:
    "Learn about Reddy Book Club and how to choose the best online cricket ID by checking security, terms, support, transactions, and legal requirements.",
  imageUrl: "/blog24.webp",
},
  {
  id: 25,
  slug: "casino-online-game-online-betting-id-guide",
  title: "For New Players, Casino Online Game and Online Betting ID Is a Safer Alternative to the Conventional Casino",
  date: "2026-09-14",
  author: "Vikash Roy",
  views: 0,
  likes: 0,
  comments: 0,
  excerpt:
    "Learn how to choose a safer casino online game and online betting ID by checking security, legal requirements, terms, privacy, and responsible gaming.",
  imageUrl: "/blog25.webp",
},
  {
  id: 26,
  slug: "reddy-book-reddy-book-club-online-cricket-platform",
  title: "Reddy Book and Reddy Book Club: Understanding Online Cricket Platforms",
  date: "2026-09-14",
  author: "Vikash Roy",
  views: 0,
  likes: 0,
  comments: 0,
  excerpt:
    "Learn about Reddy Book and Reddy Book Club, including online cricket services, account security, platform policies, responsible gaming, and legal considerations.",
  imageUrl: "/blog26.webp",
},
];

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-container">
      <Helmet>
        <title> Reddy Anna - Betting Blogs India Tips & Strategies</title>
        <meta
          name="description"
          content="Read Reddy Anna blogs for betting tips, strategies and guides on cricket, casino and sports betting."
        />
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Blog",
 "name": "Reddy Anna - Betting Blogs India Tips & Strategies",
 "url": "https://reddyannaaid.com/blogs",
 "description": "Read Reddy Anna blogs for betting tips, strategies and guides on cricket, casino and sports betting.",
 "publisher": {
   "@type": "Organization",
   "name": "Reddy Anna"
 }
}

          `}
        </script>
      </Helmet>
      <div className="blogs-title">
        <h1>
          <span className="highlight">Reddy Anna</span> Latest Blogs
        </h1>
      </div>

      <div className="blog-cards">
        {blogsData.map((blog) => (
          <div key={blog.id} className="blog-card">
            <img src={blog.imageUrl} alt={blog.title} className="blog-image" />
            <div className="blog-content">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-meta">
                By <span className="blog-author">{blog.author}</span> |{" "}
                <span className="date-published">
                  Published on:{" "}
                  <time dateTime={blog.date}>
                    {new Date(blog.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </time>
                </span>
              </p>

              <div className="blog-stats">
                <span>👁 {blog.views}</span>
                <span>👍 {blog.likes}</span>
                <span>💬 {blog.comments} Comments</span>
              </div>
              <p className="blog-excerpt">{blog.excerpt}</p>
              <Link to={`/blogs/${blog.slug}`} className="read-more-button">
                Read More
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
